<match-display-wrapper
    matchLabel="{{ l10nKeys.tlsFingerprintLabel | vtranslate }}"
    matchCriteria="{{ matchCriteria }}"
>
    <div>
        <div *ngFor="let tlsFingerprint of tlsFingerprints; trackBy: trackByIndex">
            {{ tlsFingerprint }}
        </div>
    </div>
</match-display-wrapper>
